import { useState } from "react";
import { GraduationCap, HeartHandshake, Megaphone, HandCoins, CalendarCheck } from "lucide-react";
import { MyAttendance } from "@/components/MyAttendance";
import { MyGiving } from "@/components/MyGiving";
import { MyAnnouncements } from "@/components/MyAnnouncements";
import { MyTrainings } from "@/components/MyTrainings";
import { MyMinistries } from "@/components/MyMinistries";

const TABS = [
  { key: "attendance", label: "My Attendance", icon: CalendarCheck },
  { key: "giving", label: "My Giving", icon: HandCoins },
  { key: "trainings", label: "Trainings", icon: GraduationCap },
  { key: "ministries", label: "Ministries", icon: HeartHandshake },
  { key: "announcements", label: "Announcements", icon: Megaphone },
];

export const PortalSections = () => {
  const [open, setOpen] = useState(null);
  return (
    <div className="space-y-4" data-testid="portal-sections">
      <div className="flex flex-wrap gap-3">
        {TABS.map(({ key, label, icon: Icon }) => {
          const active = open === key;
          return (
            <button key={key} type="button" onClick={() => setOpen(active ? null : key)} aria-pressed={active}
              data-testid={`portal-${key}-button`}
              className={`flex items-center gap-2 rounded-full px-6 py-3 text-sm font-semibold border transition-colors duration-200 ${
                active ? "bg-[#2D5A27] text-white border-[#2D5A27]" : "bg-white text-[#2D5A27] border-[#2D5A27] hover:bg-[#EAF2E8]"}`}>
              <Icon className="h-4 w-4" /> {label}
            </button>
          );
        })}
      </div>
      {open === "attendance" && <MyAttendance />}
      {open === "giving" && <MyGiving />}
      {open === "trainings" && <MyTrainings />}
      {open === "ministries" && <MyMinistries />}
      {open === "announcements" && <MyAnnouncements />}
    </div>
  );
};
